import React, { ComponentType } from 'react'
import { IconButton, Typography } from '@mui/material'
import clsx from 'clsx'
import { useStyles } from './AddUpdateButton.styles'

export type AddUpdateButtonProps = {
  label: string
  onClick?: () => void
  disabled: boolean
  icon?: ComponentType<{ className?: string }>
  type: string
}

export const AddUpdateButton = React.memo(
  ({ label, onClick, disabled, icon, type }: AddUpdateButtonProps) => {
    const Icon = icon
    const { classes } = useStyles()
    return (
      <IconButton
        onClick={onClick}
        className={clsx(
          classes.addIconButton,
          disabled ? classes.disabledButton : ''
        )}
        disabled={disabled}
        data-testid={`${type}-button`}
        size="large"
      >
        {Icon && (
          <Icon
            className={clsx(
              classes.addIcon,
              disabled ? classes.disabledButton : ''
            )}
          />
        )}
        <Typography
          className={clsx(
            classes.addIconLabel,
            disabled ? classes.disabledButton : ''
          )}
          data-testid="add-update-button-label"
        >
          {label}
        </Typography>
      </IconButton>
    )
  }
)
